// ArtifactCard — inline artifact display in agent messages

import { Link } from "react-router-dom";
import { buildBrandScopedPath } from "../../lib/brand-navigation";
import { apiUrl } from "../../lib/api";

interface ArtifactCardProps {
  name: string;
  contentType: string;
  preview: string | null;
  artifactKey: string;
  /** Retains the active workspace brand when this card is rendered in shell chat. */
  brandId?: string | null;
  onView?: () => void;
}

const typeIcons: Record<string, string> = {
  "text/markdown": "📄",
  "text/plain": "📝",
  "text/html": "🌐",
  "image/png": "🖼",
  "image/jpeg": "🖼",
  "application/json": "📊",
};

export function ArtifactCard({ name, contentType, preview, artifactKey, brandId, onView }: ArtifactCardProps) {
  const icon = typeIcons[contentType] || "📎";

  return (
    <div className="my-2 rounded-lg border border-slate-200 bg-slate-50 p-3 text-sm">
      <div className="flex items-center gap-2">
        <span>{icon}</span>
        <span className="flex-1 font-medium text-slate-800 truncate">{name}</span>
      </div>
      {preview && (
        <p className="mt-1 text-xs text-slate-500 line-clamp-3">{preview}</p>
      )}
      <div className="mt-2 flex gap-2">
        {onView && (
          <button
            type="button"
            onClick={onView}
            className="rounded bg-white border border-slate-200 px-2 py-1 text-xs text-slate-600 hover:bg-slate-100"
          >
            View
          </button>
        )}
        <Link
          to={buildBrandScopedPath(`/outputs/agent_artifact/${encodeURIComponent(artifactKey)}`, brandId)}
          className="rounded bg-white border border-slate-200 px-2 py-1 text-xs text-slate-600 hover:bg-slate-100"
        >
          Open output
        </Link>
        <a
          href={apiUrl(`/api/agent/artifacts/${encodeURIComponent(artifactKey)}`)}
          download={name}
          className="rounded bg-white border border-slate-200 px-2 py-1 text-xs text-slate-600 hover:bg-slate-100"
        >
          Download
        </a>
      </div>
    </div>
  );
}
